'use strict';

var GridToolbarSystemStatusHistoryController = function GridToolbarSystemStatusHistoryController() {};
GridToolbarSystemStatusHistoryController.$inject = [];
module.exports = GridToolbarSystemStatusHistoryController;